/**
 * PE-1830 (AC#6/#7): surfaces a per-merchant link to Microsoft Clarity session
 * recordings / heatmaps. Render this only behind
 * Permission.OBSERVABILITY_SESSION_RECORDINGS_VIEW and pass the ACTIVE merchant's
 * Clarity project id (from `merchant.clarityProjectId`) — that enforces the
 * access rule (merchant admins resolve only their own merchant; TCS admins
 * resolve whichever merchant they're viewing).
 */
import { clarityDashboardUrl } from '../../lib/clarityProjects';

interface MerchantSessionRecordingsProps {
  projectId: string | null | undefined;
  merchantName?: string;
}

export default function MerchantSessionRecordings({
  projectId,
  merchantName,
}: MerchantSessionRecordingsProps) {
  const subject = merchantName ? merchantName : 'this merchant';

  return (
    <div className="bg-card rounded-lg border border-border p-6">
      <div className="flex items-center justify-between gap-4">
        <div>
          <h2 className="text-base font-semibold text-foreground">Session Recordings</h2>
          <p className="text-sm text-foreground mt-1">
            View storefront session recordings, heatmaps and click maps for {subject} in
            Microsoft Clarity.
          </p>
        </div>
        {projectId ? (
          <a
            href={clarityDashboardUrl(projectId)}
            target="_blank"
            rel="noreferrer noopener"
            className="shrink-0 inline-flex items-center rounded-md bg-[#28282A] px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-black"
          >
            Open in Clarity
          </a>
        ) : (
          <span className="shrink-0 text-sm italic text-foreground">Not configured yet</span>
        )}
      </div>
    </div>
  );
}
